import { API, AppConfig } from 'lib';
import React, { useState } from 'react'


const configMap = {

    Plan: { key: 'Plan', value: 1, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Addressbook: { key: 'Addressbook', value: 2, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    LR: { key: 'LR', value: 3, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    JK_LR: { key: 'JK_LR', value: 4, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    ADANI_LR: { key: 'ADANI_LR', value: 9, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Contract_Rate_City_City: { key: 'Contract_Rate_City_City', value: 5, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Contract_Rate_Zone_Zone: { key: 'Contract_Rate_Zone_Zone', value: 6, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Fastag: { key: 'Fastag', value: 7, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Fuel_Card: { key: 'Fuel_Card', value: 8, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Gain_penalty: { key: 'Gain_penalty', value: 11, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },
    Iocl_Fuel: { key: 'Iocl_Fuel', value: 10, api: `${AppConfig.api_baseurl}${API.SAMPLE_UPLOAD}` },

};

const ButtonExcelForQuick = (props) => {

    let { name } = props;
    const [loading, setLoading] = useState(false);
    let isToken = localStorage.getItem("token");

    const getDownloadList = async (event) => {
        event.preventDefault();
        setLoading(true)
        try {
            let selectedConfig = configMap[name];
            const payload = {

                id: selectedConfig.value
            };


            const baseUrl = `${selectedConfig.api}`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const disposition = response.headers.get('Content-Disposition');
            let fileName = `${name}-list.xlsx`; // default fallback

            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    return (


        <button className="excel-btn" onClick={(e) => getDownloadList(e)}>
            <img
                className="excel-icon"
                src="https://img.icons8.com/color/24/000000/ms-excel.png"
                alt="Excel Icon"
                disabled={loading}
            />
            {loading ? 'Loading...' : 'Sample File'}
        </button>

    )
}

export default React.memo(ButtonExcelForQuick)